import React from 'react';
import {Text, IconTooltip} from '@forecast-it/design-system';

function TaskRequiredInfo(): JSX.Element {
	return (
		<>
			<Text size={'2'}>You need to select a task to create a time registration.</Text>
			<Text size={'2'} color={'medium'}>
				This is a company-wide setting configured by your admin.
			</Text>
		</>
	);
}

export function TaskRequiredInfoIcon(): JSX.Element {
	return (
		<IconTooltip icon={'info'} color={'disabled'} iconSize={'s'}>
			<TaskRequiredInfo />
		</IconTooltip>
	);
}

export function TaskRequiredError(): JSX.Element {
	return (
		<Text color={'error'} size={'2'}>
			Selecting a task is required for time entries. This is a company-wide setting.
		</Text>
	);
}
